<template>
  <div style="margin-top: 50px;overflow-x: hidden">
    <!-- class="row course-wrapper course-radius-none mb-30 mobile-pc" -->
    <!-- border: 1cm solid #F6F6F6; -->
    <div style="margin-top: 20px; background-color: #f6f6f6">
      <div
        id="teacher_content"
        style="
          margin-top: 20px;
          background-color: white;
          margin-left: 2%;
          margin-right: 2%;
        "
        class="row course-wrapper course-radius-none mb-30 mobile-pc"
      >
        <div>
          <div class="mobile-pc-box" style="margin-left: 4%; float: left">
            <div class="courses-thumb">
              <img
                :src="user.pic"
                prop="image"
                alt=""
                style="width: 200px; height: 300px"
              />
            </div>
          </div>
          <div
            class="course-main-content clearfix col-12 col-xl-9 col-sm-12 col-lg-9 col-md-9"
          >
            <div class="">
              <div style="display: flex">
                <!-- <a href="" prop="name"   class="names" style="font-size: 30px; text-decoration: none; "></a>  -->
                <h2>{{ user.name }}</h2>
              </div>

              <div
                class="course_teacher"
                style="height: 35px; display: flex; align-items: center"
              >
                <div
                  class=""
                  style="float: left; background-color: #fff0f5; height: 35px"
                >
                  <div style="padding: 5px">
                    <img
                      src="https://www.zljst.com/subpage/lecturer_details/img/opeart_logo1.png"
                      style="margin-left: 15px; margin-top: -5px"
                      alt=""
                    />
                    <span
                      id="authIdcard"
                      style="
                        margin-left: 2px;
                        margin-right: 15px;
                        color: red;
                        font-size: 18px;
                      "
                      >身份未认证</span
                    >
                  </div>
                </div>

                <div
                  class=""
                  style="
                    float: left;
                    background-color: #fff0f5;
                    height: 35px;
                    margin-left: 15px;
                  "
                >
                  <div style="padding: 5px">
                    <img
                      src="https://www.zljst.com/subpage/lecturer_details/img/opeart_logo2.png"
                      alt=""
                      style="margin-left: 15px; margin-top: -5px"
                    />
                    <span
                      id="authOrgin"
                      style="
                        margin-left: 2px;
                        margin-right: 15px;
                        color: red;
                        font-size: 18px;
                      "
                      >机构未认证</span
                    >
                  </div>
                </div>
                <div
                  class=""
                  style="background-color: rgba(0, 0, 0, 0); margin-left: 15px"
                >
                  <img
                    src="https://www.zljst.com/subpage/lecturer_details/img/opeart_logo5.png"
                    alt=""
                  />
                  <span id="browseCount" style="color: #000">0</span>
                </div>
              </div>

              <div
                class="element"
                style="font-size: 15px; line-height: 2; margin-top: 10px ;"
              >
               <div v-html="user.aptitude"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center contain">
      <div
        class="col-12 courses-wrapper course-radius-none"
        style="max-width: 100%; border-top: 3px solid #d52330; margin-top: 4%"
      >
        <div style="margin-bottom: 10px;">
          <div class="nav-body">
            <ul
              class="nav nav-pills nav-justified mb-3"
              id="pills-tab"
              role="tablist"
            >
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link active"
                  id="pills-info-tab"
                  data-toggle="pill"
                  v-on:click="handleClick1"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                  style="cursor: pointer;"
                  >基本信息</a
                >

              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link"
                  id="pills-courses-tab"
                  v-on:click="handleClick2"
                  data-toggle="pill"
                  role="tab"
                  aria-controls="pills-courses"
                  aria-selected="false"
                  style="cursor: pointer;"
                  >主讲课程</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div v-show="jibenxinxi">
          <div style="margin-left: 4%">
            <div style="font-size: 23px; font-weight: bold">
              <span>基本信息</span>
              <span style="color: #bebebe">· INFORMATION</span>
            </div>
            <div id="info-first-content">
              <div v-html="user.contentDetails"></div>
            </div>
          </div>
        </div>
        <div style="margin:10px 2%; width: 100%" v-show="zhujiangkecheng">
          <div >
            <div style="font-size: 23px; font-weight: bold">
              <span>主讲课程</span>
              <span style="color: #bebebe">· SPEAKER</span>
            </div>
            <div
              id="info-courses-content"
              class="list_container"
              style="margin-top: 2%"
            >
              <div
                class="list_container_item"
                v-for="(item, index) in courseList"
                :key="index"
              >
                <div class="list_container_item_img">
                  <img
                    :src="item.pic"
                    alt=""
                    style="width: 100%; height: 100%"
                  />
                </div>
                <div
                  class="list_container_item_span"
                  onclick="getNewsInfo('&quot;VG4NtQEB/Yin8ZSvHVPfMw==&quot;','2')"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { name } from "file-loader";

export default {
  data() {
    return {
      jibenxinxi: true,
      zhujiangkecheng: false,
      activeName: "second",
      searchQuery: "",
      user: [],
      courseList: [],
      teacherId:'',
    };
  },
  created() {
    this.getTeacherDetail();
    console.log('teacherId',this.$route.params.id);
    this.teacherId = this.$route.params.id;
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleClick1(tab, event) {
      this.jibenxinxi = true;
      this.zhujiangkecheng = false;
    },
    handleClick2(tab, event) {
      this.jibenxinxi = false;
      this.zhujiangkecheng = true;
      this.getCourseList();
    },
    getTeacherDetail() {
      let _this = this;
      let id = _this.$route.params.id;
      console.log("getTeacherDetailid:", id);
      _this.$api.lecturerZ
        .getTeacherDetail(id)
        .then((res) => {

          if (res.code == _this.$commons.RespCode.success) {
            _this.user = res.data;
          }
        })
        .catch(() => {});
    },
    getCourseList() {
      let _this = this;
      let lecturerId = _this.$route.params.id
      _this.$api.courseZ
        .getCourseListByLecturer(_this.teacherId)
        .then((res) => {
          console.log("getCourseListres:", res);
          if (res.code == _this.$commons.RespCode.success) {
            if (res.data.length > 0) {
              _this.courseList = res.data;
            }
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
/* .element:hover {
  color:red;
} */
a.names:hover {
  color: red;
}

.el-tabs__item {
  font-size: 20px;
}

.course_teacher_itemDiv {
  padding-left: 5px;
  padding-right: 5px;
}
.list_container{
  display: flex;
  flex-wrap: wrap;
  gap: 20px; /* 项目间距 */
}
.list_container_item{
  width: calc(32% - 10px);
}
</style>



// WEBPACK FOOTER //
// src/view/specialist/index2.vue